import { serviceWorkerManager } from './service-worker'

export interface TimerNotificationEvent {
  /** Stable id so duplicate posts replace the same scheduled timeout. */
  id: string
  /** Absolute timestamp (ms since epoch) at which the notification should fire. */
  at: number
  kind: 'prewarn_15s' | 'phase_change'
  title: string
  body: string
  /** Pattern passed to the Notification API. */
  vibrate: number[]
}

export function scheduleTimerNotifications(events: TimerNotificationEvent[]): void {
  if (typeof navigator === 'undefined' || !navigator.serviceWorker?.controller) return
  serviceWorkerManager.sendMessage('TIMER_SCHEDULE_NOTIFICATIONS', { events })
}

export function cancelTimerNotifications(): void {
  if (typeof navigator === 'undefined' || !navigator.serviceWorker?.controller) return
  serviceWorkerManager.sendMessage('TIMER_CANCEL_NOTIFICATIONS')
}
